/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Columns_TitleInputs */



/**
* | output |
* | --- |
* | "Columns" |
*
* @param {Editor_Table_Columns_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_columns_title = /** @type {((inputs?: Editor_Table_Columns_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Columns_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Colonnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colonne")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Колонки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Columnas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("列")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コラム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कॉलम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colunas")
	return /** @type {LocalizedString} */ ("Columns")
});